import { axiosAction } from "../../utils/axiosAction";

import {
  REPORTING_UNITS_CLEAR,
  REPORTING_UNITS_CLEAR_FILTER_VALUE,
  REPORTING_UNITS_FETCH,
  REPORTING_UNITS_FETCH_BY_BRAND,
  REPORTING_UNITS_FETCH_RESTAURANTS,
  REPORTING_UNITS_GROUP_RESTAURANTS_FETCH,
  REPORTING_UNITS_GROUPS_FETCH,
  REPORTING_UNITS_SET_FILTER_VALUE,
  REPORTING_UNITS_GROUPS_COUNTRIES_FETCH
} from "../action-types/reporting-unit-types";

const ENDPOINT_RESTAURANTS = `${process.env.REACT_APP_ENDPOINT_REPORTING_UNITS_RESTAURANTS}`;

export const clearReportingUnits = () => ({
  type: REPORTING_UNITS_CLEAR,
});
export const setFilterValue = payload => ({
  type: REPORTING_UNITS_SET_FILTER_VALUE,
  payload,
});
export const clearFilterValue = () => ({
  type: REPORTING_UNITS_CLEAR_FILTER_VALUE,
});
export const getReportingUnits = (brand, code) => async dispatch => {
  const endpoint = `/v1/brands/${brand}/hierarchy?code=0`;
  return axiosAction.get(endpoint, REPORTING_UNITS_FETCH, dispatch);
};
export const getReportingUnitsRestaurants =
  (reportingUnit, brand) => async dispatch => {
    const endpoint = `${ENDPOINT_RESTAURANTS}/brands/${brand}/hierarchy?code=${reportingUnit}`;
    return axiosAction.get(
      endpoint,
      REPORTING_UNITS_FETCH_RESTAURANTS,
      dispatch,
    );
  };
export const fetchBrandReportingUnits = brand => async dispatch => {
  const endpoint = `/v1/franchise/reporting-units?brand=${brand}`;
  return axiosAction.get(endpoint, REPORTING_UNITS_FETCH_BY_BRAND, dispatch, {
    meta: {
      brand,
    },
  });
};
export const fetchReportingUnitGroups =
  (brand, reportUnitId, params: any = {}) => async dispatch => {
    const { country } = params;
    const endpoint = `/v1/franchise/reporting-units/${reportUnitId}/groups`;
    return axiosAction.get(endpoint, REPORTING_UNITS_GROUPS_FETCH, dispatch, {
      meta: {
        brand,
        reportUnitId,
      },
      params: {
        country
      }
    });
  };
export const fetchReportingUnitGroupsCountries =
  (brand, reportUnitId) => async dispatch => {
    const endpoint = `/v1/reporting-units/${reportUnitId}/countries`;
    return axiosAction.get(endpoint, REPORTING_UNITS_GROUPS_COUNTRIES_FETCH, dispatch, {
      meta: {
        brand,
        reportUnitId,
      },
    });
  };

export const fetchReportingUnitGroupRestaurants =
  (brand, reportUnitId, groupId, params: any = {}) =>
    async dispatch => {
      const endpoint = `/v1/reporting-unit/${reportUnitId}/group/${groupId}/restaurants`;
      const { limit = 100, page = 1 } = params;
      return axiosAction.get(
        endpoint,
        REPORTING_UNITS_GROUP_RESTAURANTS_FETCH,
        dispatch,
        {
          params: {
            limit,
            page,
            brand,
          },
          meta: {
            brand,
            reportUnitId,
            groupId,
          },
        },
      );
    };
